import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import {
  DateInput,
  DateInputProps,
} from 'src/components/enterprise/components/DateInput/DateInput';

export type BaseDateInputProps = Omit<DateInputProps, 'control' | 'error'>;

export const BaseDateInput: React.FC<BaseDateInputProps> = ({
  name,
  ...rest
}) => {
  const { errors, control } = useFormContext();

  return (
    <DateInput name={name} {...rest} control={control} error={errors[name]} />
  );
};
